import filledArray from "@-/com.npmjs.filled-array";
import { WordMorphemeGlyphTileLink } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.tile.link.glyphs";
import { useMemo } from "react";
import { View } from "@-/com.npmjs.react-native";
import arrayLength from "@-/com.npmjs.extra-array__length";
import type {
  BatchedWordTileData,
  GlyphStyle,
  MorphemeGlyphTileWordFront,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.tile.ui.glyphs";

const WORD_COLUMNS = 8;

export interface WordGridItem {
  key: string;
  simplified: string;
}

export function WordTilesGrid({
  front = "glyphs",
  prepared,
  words,
}: {
  /** Written glyphs (default) or the readings that make up each word. */
  front?: MorphemeGlyphTileWordFront;
  /** Virtualized callers prepare only the mounted row and share one navigation owner. */
  prepared?: {
    data: BatchedWordTileData;
    getGlyphStyle: (word: string) => GlyphStyle;
    onNavigate: (word: string) => void;
  };
  words: readonly WordGridItem[];
}) {
  const rows = useMemo(() => {
    const out: WordGridItem[][] = [];
    for (let i = 0; i < arrayLength(words); i += WORD_COLUMNS) {
      out.push(words.slice(i, i + WORD_COLUMNS));
    }
    return out;
  }, [words]);

  return (
    <View className="gap-1">
      {rows.map((row, rowIdx) => (
        <View className="flex-row gap-1" key={rowIdx}>
          {filledArray((colIdx) => {
            const word = row[colIdx];
            return (
              <View
                className="flex-1 items-center justify-center"
                key={word ? word.key : `empty-${rowIdx}-${colIdx}`}
              >
                {word === undefined ? (
                  <View className="aspect-square w-full" />
                ) : (
                  <WordMorphemeGlyphTileLink
                    front={front}
                    glyphStyle={prepared?.getGlyphStyle(word.simplified)}
                    href="/(nav)/(app)/browse/morpheme/[morpheme]"
                    morphemeGlyphTileSlice={prepared?.data.getSlice(word.simplified)}
                    onNavigate={prepared?.onNavigate}
                    word={word.simplified}
                  />
                )}
              </View>
            );
          }, WORD_COLUMNS)}
        </View>
      ))}
    </View>
  );
}
